// extracted by mini-css-extract-plugin
module.exports = {"b1nbax0":"b1nbax0","b1xdd47s":"b1xdd47s"};